// Quiz steps for the BS26 "Build your sale list" quiz: who → people → use/gift kind → style (photo tiles) → result.
// No "how many" question: the result always starts with 4 pieces (80% tier). Shared state lives on window.SLQ_STATE.
// Every button carries data-hc-el (HC Pixel element clicks = anonymous per-answer counts); answers also go to SLQ_TRACK.
(function () {
  const C = window.SLQ_CONFIG, L = window.SLQ_LOGIC, T = window.SLQ_TRACK || { step() {}, completed() {}, listAction() {}, saved() {} };
  const root = document.getElementById('slq');
  root.setAttribute('data-hc-section', 'sale-list-quiz');
  const qs = new URLSearchParams(location.search);
  const S = (window.SLQ_STATE = { a: { recipients: [] }, slots: [], i: 0, interacted: false, isReg: !!(window.SLQ_PAGE && window.SLQ_PAGE.reg) || qs.get('seg') === 'reg' /* REG template (reg_mode) or legacy ?seg=reg */, forWho: qs.get('for') || '' });

  const steps = () => ['who', ...(!S.a.who || S.a.who !== 'me' ? ['recipients'] : []), S.a.who === 'gifts' ? 'giftKind' : 'moment', 'look'];
  const optBtn = (attr, el, label, sub, on) =>
    `<button class="slq-opt${on ? ' is-on' : ''}" ${attr} data-hc-el="${el}"><span class="slq-opt-l">${label}</span>${sub ? `<span class="slq-opt-s">${sub}</span>` : ''}</button>`;
  // Real product photo for a style tile (prefer a bag over a wallet).
  const styleImg = (o) => { const ps = window.SLQ_PRODUCTS.filter((p) => o.designs.includes(p.design)); return (ps.find((p) => /bag|tote|backpack|crossbody/.test(p.type)) || ps[0] || {}).img || ''; };
  const styleTiles = (opts, attr, el = 'slq-look-') => '<div class="slq-cards">' + opts.map((o) => `<button class="slq-card" ${attr}="${o.id}" data-hc-el="${el}${o.id}"><img src="${L.cdnW(styleImg(o), 360)}" alt=""><span>${o.label}</span></button>`).join('') + '</div>';

  function focusHead(sel) {
    if (!S.interacted) return;
    const h = root.querySelector(sel || 'h2'); if (!h) return;
    h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true });
    const top = h.getBoundingClientRect().top; if (top < 0 || top > window.innerHeight - 120) h.scrollIntoView({ block: 'start' }); // no jumps when already visible
  }

  function renderStep() {
    const list = steps(), key = list[S.i], a = S.a;
    let body = '';
    if (key === 'who') body = `<h2>${C.who.q}</h2>` + C.who.options.map((o) => optBtn(`data-who="${o.id}"`, 'slq-who-' + o.id, o.label, o.sub)).join('');
    if (key === 'recipients') body = `<h2>${C.recipients.q}</h2><p class="slq-sub">${C.recipients.sub}</p><div class="slq-chips">` +
      C.recipients.options.map((o) => optBtn(`data-rec="${o.id}"`, 'slq-rec-' + o.id, o.label, '', a.recipients.includes(o.id))).join('') +
      `</div><button class="slq-next" data-next data-hc-el="slq-next" ${a.recipients.length ? '' : 'disabled'}>Next</button>`;
    if (key === 'moment') body = `<h2>${C.moment.q}</h2>` + C.moment.options.map((o) => optBtn(`data-moment="${o.id}"`, 'slq-moment-' + o.id, o.label, o.sub)).join('');
    if (key === 'giftKind') body = `<h2>${C.giftKind.q}</h2>` + C.giftKind.options.map((o) => optBtn(`data-kind="${o.id}"`, 'slq-kind-' + o.id, o.label, o.sub)).join('');
    if (key === 'look') {
      const gifts = a.who === 'gifts';
      body = `<h2>${gifts ? C.look.qHer : C.look.qMe}</h2>` + styleTiles(gifts ? [...C.look.options, C.look.giftOnlyExtra] : C.look.options, 'data-look');
    }
    const banner = S.forWho && !S.isReg && !document.querySelector('[data-lp-forbanner]') ? '<p class="slq-forbanner" data-hc-el="slq-for-banner">Someone sent you this quiz. Pick the bag you’d like from the sale. It takes 30 seconds.</p>' : '';
    root.innerHTML = banner + `<div class="slq-top">${S.i ? '<button class="slq-back" data-back data-hc-el="slq-back">← Back</button>' : '<span></span>'}<span class="slq-dots" aria-label="Step ${S.i + 1} of ${list.length}">${list.map((_, k) => `<i class="${k <= S.i ? 'on' : ''}"></i>`).join('')}</span></div><div class="slq-q">${body}</div>`;
    focusHead();
  }

  function answer(step, value) {
    T.step(step, value);
    if (S.i < steps().length - 1) { S.i++; renderStep(); return; }
    S.slots = L.buildList(S.a);
    window.SLQ_RESULT.render();
    T.completed(S.a, S.slots);
  }
  function restart() { S.a = { recipients: [] }; S.i = 0; S.textedB26 = false; renderStep(); }

  root.addEventListener('click', (e) => {
    const b = e.target.closest('button,a'); if (!b) return;
    S.interacted = true;
    const d = b.dataset, a = S.a;
    if ('back' in d) { S.i--; renderStep(); }
    else if (d.who) { S.a = { who: d.who, recipients: [] }; answer('who', d.who); }
    else if (d.rec) { a.recipients = a.recipients.includes(d.rec) ? a.recipients.filter((x) => x !== d.rec) : [...a.recipients, d.rec]; renderStep(); }
    else if ('next' in d) answer('recipients', a.recipients.join(','));
    else if (d.moment) { a.moment = d.moment; answer('moment', d.moment); }
    else if (d.kind) { a.giftKind = d.kind; answer('giftKind', d.kind); }
    else if (d.look) { a.look = d.look; answer('look', d.look); }
  });

  window.SLQ_STEPS = { restart, focusHead, styleTiles };

  // Boot: a saved/shared list (?list=) opens the result; a quiz sent by a friend (?for=) shows a banner.
  let shared = (qs.get('list') || '').split(',').filter(Boolean), source = 'open-shared-list';
  if (!shared.length) { try { shared = JSON.parse(localStorage.getItem('slq-list') || '[]'); source = 'open-saved-list'; } catch (_) { shared = []; } } // returning visitor sees their list
  if (S.forWho) T.listAction('open-from-share', S.forWho);
  if (shared.length) {
    S.slots = shared.map((h) => window.SLQ_PRODUCTS.find((p) => p.handle === h)).filter(Boolean)
      .map((p) => (qs.get('src') === 'share' && source === 'open-shared-list' ? { key: 'l-' + p.handle, forLabel: 'On the list sent to you', whyOf: () => 'Picked by the person who sent it', product: p, alts: [] }
        : { key: 'l-' + p.handle, forLabel: 'On your list', whyOf: () => 'Saved on this phone', product: p, alts: [] }));
    T.listAction(source, S.slots.length);
  }
  if (T.view) T.view(S.slots.length ? source : 'quiz');
  if (S.slots.length) window.SLQ_RESULT.render(); else renderStep(); // stale handles → start the quiz
})();
